import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { concatMap, map, switchMap, tap } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { User } from 'app/classes/user';
import { EditProfileDialogComponent } from 'app/components/edit-profile-dialog/edit-profile-dialog.component';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class EmailSubdomainGuard implements CanActivate {
  dialogRef: MatDialogRef<EditProfileDialogComponent>;

  constructor(private authService: AuthService, private dialog: MatDialog) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<any> {
    return this.authService.getApprovedDomains().pipe(
      concatMap(() => this.authService.checkForLogin()),
      switchMap(user => {
        return this.openProfileDialog(user);
      }),
    );
  }

  openProfileDialog(user) {
    if (user.email_domain_approved || this.isEmailApproved(user.email, user)) {
      return of(true);
    } else if (user && user.hasProfilePic && !user.profilePicture) {
      return this.authService.getUserImage(user.uuid).pipe(
        switchMap(() => {
          return this.openEditProfileDialog(user);
        }),
      );
    } else {
      return this.openEditProfileDialog(user);
    }
  }

  openEditProfileDialog(user) {
    if (!this.dialogRef) {
      this.dialogRef = this.dialog.open(EditProfileDialogComponent, {
        width: '500px',
        data: user,
        disableClose: true,
      });
    }
    return this.dialogRef.afterClosed().pipe(
      tap(userData => {
        if (userData) {
          this.authService.saveProfileUpdates(userData);
        }
      }),
      map((userData: any) => {
        if (userData) {
          return this.isEmailApproved(userData.email, userData);
        } else {
          return false;
        }
      }),
    );
  }

  isEmailApproved(email: string, user?: User) {
    if (user && user.email_domain_approved) {
      return true;
    }
    let found = false;
    for (const e of this.authService.approvedEmailDomains) {
      if (email.includes(e)) {
        found = true;
      }
    }
    return found;
  }
}
